import { api } from './util';

/**
 * Procedure Tag - show form in procedure detail.
 */
(function ($) {
	$(document).on('click', '.detail-tags .add-tag', function () {
		var btn = $(this);
		var form = btn.parent().find('.form-add-tag');

		if (btn.hasClass('add-tag-close')) {
			btn.removeClass('add-tag-close');
			form.removeClass('form-add-tag-show');
		} else {
			btn.addClass('add-tag-close');
			form.addClass('form-add-tag-show');
		}
	});
})(jQuery);

/**
 * Procedure Tag - show form in procedure search.
 */
(function ($) {
	let closeActiveTagPopup = function () {
		$('.add-tag-close').removeClass('add-tag-close');
		$('.item-table-tag-content').hide();
	};

	$(document).on('click', '.item-table-tag .add-tag', function () {
		var btn = $(this);
		var form = btn.parent().find('.item-table-tag-content');

		if (btn.hasClass('add-tag-close')) {
			btn.removeClass('add-tag-close');
			form.hide();
		} else {
			closeActiveTagPopup();
			btn.addClass('add-tag-close');
			form.show();
		}
	});

	document.onkeydown = function (event) {
		event = event || window.event;
		let isEscape = 'key' in event ? event.key === 'Escape' || event.key === 'Esc' : event.keyCode === 27;

		if (isEscape) {
			closeActiveTagPopup();
		}
	};

	// Hide popup when user clicks outside
	$(document).click(function (event) {
		if (!$(event.target).hasClass('add-tag') && $(event.target).parents('.item-table-tag-content').length === 0) {
			closeActiveTagPopup();
			event.stopPropagation();
		}
	});
})(jQuery);

/**
 * Procedure Tag - REST call for creating procedure tag (both in procedure detail and search).
 */
var procedureTag = (function ($) {
	var getDataFromForm = function (form) {
		var tag = form.find('[name=tag]').val().trim();
		return {
			tag: tag,
		};
	};

	var getApiUrlFromForm = function (form) {
		var procedureId = form.find('[name=procedureId]').val();
		return '/users/' + encodeURIComponent(api.getUserId()) + '/procedures/' + encodeURIComponent(procedureId) + '/tag';
	};

	var processApiResponse = function (response, form) {
		let procedureTag = response.procedureTag;
		let tag = procedureTag.tag;
		let name = tag.name;

		let tagsList = form.parent().parent().find('.tags-list');
		if (tagsList.find('[data-procedure-tag-id="' + procedureTag.id + '"]').length === 0) {
			let nameLink = $('<a>').attr('href', 'javascript:;').addClass('btn-tag-item').text(name);

			let deleteLink = $('<a>')
				.attr('href', 'javascript:;')
				.attr('data-procedure-tag-id', procedureTag.id)
				.attr('data-procedure-id', procedureTag.procedureId)
				.addClass('btn-remove-tag');

			let p = $('<p>')
				.addClass('p-tag')
				.addClass('i-' + procedureTag.tag.color)
				.append(nameLink)
				.append(deleteLink);

			tagsList.append(p);
		}

		let tagsList2 = form.parents('.item-tag').find('.p-tags');
		if (tagsList2.find('[data-procedure-tag-id="' + procedureTag.id + '"]').length === 0) {
			let tagI = $('<i>')
				.addClass('i-' + procedureTag.tag.color)
				.text(name);
			let tagSpan = $('<span>')
				.attr('data-procedure-tag-id', procedureTag.id)
				.attr('data-procedure-id', procedureTag.procedureId)
				.html(tagI);

			tagsList2.append(tagSpan);
		}

		form.find('[name=tag]').val('').trigger('change');
		form.parents('.item-tag-content').removeClass('item-tag-content-empty');
	};

	var processApiRequest = function (formSelector) {
		var form = $(formSelector);
		var url = getApiUrlFromForm(form);
		var data = getDataFromForm(form);

		return api.put(url, data).done(function (response) {
			processApiResponse(response, form);
		});
	};

	$(document).on('submit', '.add-procedure-tag-form', function () {
		var form = $(this);
		var button = form.find('.btn-addtag');
		var tagValue = form.find('[name=tag]').val();

		if (tagValue == null) {
			return false;
		}

		var tagTrimmedValue = tagValue.trim();

		if (tagTrimmedValue.length === 0) {
			return false;
		}

		button.prop('disabled', true);
		processApiRequest(this).always(function () {
			button.prop('disabled', false);
		});

		return false;
	});

	var getAjaxProcessResults = function () {
		return function (response) {
			var results = [];
			return {
				results: results.concat(
					response.items.map(function (item) {
						return {
							id: item['name'],
							text: item['name'],
							item: item,
						};
					})
				),
				pagination: {
					more: response.pagination && response.pagination.currentPage < response.pagination.totalPages,
				},
			};
		};
	};

	var initSelect = function (select) {
		select.select2({
			tags: true,
			ajax: $.extend(api.getAjaxOptions('/tags'), {
				delay: 250,
				data: function (params) {
					if (params.term && params.term.trim() !== '') {
						return { 'filter-all': params.term };
					} else {
						return {};
					}
				},
				processResults: getAjaxProcessResults(),
			}),
		});
	};

	var init = function () {
		$('select.add-tag-select').select2({
			tags: true,
			ajax: $.extend(api.getAjaxOptions('/tags'), {
				delay: 250,
				data: function (params) {
					if (params.term && params.term.trim() !== '') {
						return { 'filter-all': params.term };
					} else {
						return {};
					}
				},
				processResults: getAjaxProcessResults(),
			}),
		});
	};

	return {
		init: init,
		initSelect: initSelect,
	};
})(jQuery);

/**
 * Procedure Tag - REST call for deleting procedure tag (both in procedure detail and search).
 */
(function ($) {
	var processApiRequest = function () {
		var btn = $(this);
		var procedureTagId = btn.data('procedureTagId');
		var procedureId = btn.data('procedureId');
		var url =
			'/users/' +
			encodeURIComponent(api.getUserId()) +
			'/procedures/' +
			encodeURIComponent(procedureId) +
			'/tag/' +
			encodeURIComponent(procedureTagId);

		return api.delete(url).done(function () {
			btn
				.parents('.item-tag')
				.find('.p-tags [data-procedure-tag-id="' + procedureTagId + '"]')
				.remove();
			if (btn.parents('.item-tag-content').find('.p-tags span').length === 0) {
				btn.parents('.item-tag-content').addClass('item-tag-content-empty');
			}
			btn.parent().remove();
		});
	};

	$(document).on('click', '.btn-remove-tag', processApiRequest);
})(jQuery);

export { procedureTag };
